import Api from './Api';

import axios from "axios";

// import VueAxios from 'vue-axios'
// if (axios) {
//
// }

var api = new Api(axios)

export default api;
